import type { CSSProperties } from 'react';

type AppEnv = 'production' | 'staging' | 'integration' | 'local' | 'e2e';

type EnvHeaderTheme = {
  background: NonNullable<CSSProperties['background']>;
  borderColor: NonNullable<CSSProperties['borderColor']>;
};

const PRODUCTION_THEME: EnvHeaderTheme = { background: '#FFFFFF', borderColor: '#DEE0E3' };

const ENV_HEADER_THEMES: Record<AppEnv, EnvHeaderTheme> = {
  production: PRODUCTION_THEME,
  staging: { background: '#EEF2FF', borderColor: '#C7D2FE' },
  integration: { background: '#F5D0FE', borderColor: '#E879F9' },
  local: { background: 'repeating-linear-gradient(135deg, #FEF3C7 0 12px, #FDE68A 12px 24px)', borderColor: '#FCD34D' },
  e2e: { background: 'repeating-linear-gradient(135deg, #FEF3C7 0 12px, #FDE68A 12px 24px)', borderColor: '#FCD34D' },
};

export function getEnvHeaderTheme(): EnvHeaderTheme {
  const env = process.env.AGRIFUL_ENV as AppEnv | undefined;
  return env && env in ENV_HEADER_THEMES ? ENV_HEADER_THEMES[env] : PRODUCTION_THEME;
}
